import { supabase } from './api'

// Current Level Reports – View: courselessoncurrentlevelreport
export async function getCourseLessonCurrentLevelReports(studentId) {
	const { data, error } = await supabase.from('courselessoncurrentlevelreport').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch current level reports')
	return data
}

// Level Reports – View: courselessonlevelreport
export async function getCourseLessonLevelReports(studentId) {
	const { data, error } = await supabase.from('courselessonlevelreport').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch level reports')
	return data
}

// Grade Year Reports – View: courselessongradeyearreport
export async function getCourseLessonGradeYearReports(studentId) {
	const { data, error } = await supabase.from('courselessongradeyearreport').select().eq('studentId', studentId)
	if (error) throw new Error('Failed to fetch grade year reports')
	return data
}

// Overview – Table: courselessonsdesc
export async function getOverviewTexts(studentId) {
	const { data, error } = await supabase.from('courselessondesc').select().eq('studentId', studentId)

	if (error) {
		console.error('Supabase error:', error)
		throw new Error('Failed to fetch overview data')
	}

	return data
}

export async function saveOverviewTexts(studentId, overviewMap) {
	for (const [type, desc] of Object.entries(overviewMap)) {
		// Sadece bu type'ı sil
		const deleteRes = await supabase.from('courselessondesc').delete().eq('studentId', studentId).eq('type', type)

		if (deleteRes.error) {
			console.error(`Error deleting overview for ${type}:`, deleteRes.error.message)
			throw new Error('Failed to delete previous overview data')
		}

		// Yeni overview satırını ekle
		const { error } = await supabase.from('courselessondesc').insert([{ studentId, type, desc }])

		if (error) {
			console.error(`Error inserting overview for ${type}:`, error.message)
			throw new Error('Failed to insert new overview data')
		}
	}
}

// Average GPA (%) verilerini alan fonksiyon
export async function getGpaPercentAverages(studentId) {
	const { data, error } = await supabase.from('courselessoncurrentaveragereport').select().eq('studentId', studentId)

	if (error) {
		console.error('GPA average fetch error:', error.message)
		throw new Error('Failed to fetch GPA averages')
	}

	return data
}

export async function getCalculatedGpaAverages(studentId) {
	const { data, error } = await supabase.from('courselessoncurrentaveragereport').select('*').eq('studentId', studentId)

	if (error) {
		console.error('Calculated GPA fetch error:', error.message)
		throw new Error('Failed to fetch GPA for 4.0 scale')
	}

	return data
}
